import { Redirect } from 'expo-router';
import React from 'react';

export default function AdvanceApprovedCongratsPage() {
  return <Redirect href="/varo-advance/approved" />;
}
